import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/dashboard/roi/')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/roi/$canvasId',
      params: { canvasId: 'summary' },
    });
  },
});
